import { useState } from "react";

const faqData = [
  {
    question: "Is MBBS abroad valid in India?",
    answer: (
      <p>
        Yes, MBBS from NMC-approved foreign universities is valid in India after clearing FMGE or NExT exam.
      </p>
    ),
  },
  {
    question: "Is NEET required for MBBS abroad?",
    answer: (
      <p>
        Yes, NEET qualification is mandatory for Indian students to study MBBS abroad as per NMC rules.
      </p>
    ),
  },
  {
    question: "Which country is best for MBBS abroad?",
    answer: (
      <p>
        Russia, Georgia, Uzbekistan,malasia and Nepal are popular choices due to affordable fees and good education quality.
      </p>
    ),
  },
  {
    question: "What is the total cost of MBBS abroad?",
    answer: (
      <p>
        The total cost ranges between ₹16 lakh to ₹40 lakh depending on the country, university, and living expenses.
      </p>
    ),
  },
  {
    question: "Can I work in India after MBBS abroad?",
    answer: (
      <p>
        Yes, after clearing FMGE or NExT exam and completing required formalities, you can practice in India.
      </p>
    ),
  },
  {
    question: "Is IELTS or TOEFL required?",
    answer: (
      <p>
        Most countries like Russia, Georgia  do not require IELTS/TOEFL. Some countries may require it.
      </p>
    ),
  },
  {
    question: "What is the duration of MBBS abroad?",
    answer: (
      <p>
        MBBS abroad typically takes 5 to 6 years including internship.
      </p>
    ),
  },
  {
    question: "What is eligibility for MBBS abroad?",
    answer: (
      <p>
        Students must have 10+2 with PCB (50% marks for general category) and must qualify NEET exam.
      </p>
    ),
  },
  {
    question: "Are scholarships available for MBBS abroad?",
    answer: (
      <p>
        Yes, some universities and governments offer scholarships based on merit or financial need.
      </p>
    ),
  },
  {
    question: "What is the medium of teaching?",
    answer: (
      <p>
        Most universities offer MBBS courses in English medium for international students.
      </p>
    ),
  },
];

export default function FaqSection() {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
      <h2
        className="sm:text-3xl text-2xl font-bold text-center capitalize"
        style={{ color: "#140342", fontSize: "28.125px" }}
      >
        Frequently asked <span className="text-[#ff9245]">questions</span>
      </h2>
      <div className="mt-8 space-y-4 ml-6 mr-6">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`p-4 border rounded-lg shadow-md ${
              activeFAQ === index ? "bg-gray-50" : ""
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex justify-between items-center cursor-pointer">
              <h3
                className="text-lg font-semibold"
                style={{ color: "#140342", fontSize: "16.875px" }}
              >
                {faq.question}
              </h3>
              <span>{activeFAQ === index ? "-" : "+"}</span>
            </div>
            <div
              className={`mt-2 text-gray-600 text-left text-lg ${
                activeFAQ === index ? "block" : "hidden"
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
